export default function MessagingHelpers() {
  this.safeHtml = (value) => {
    if (!value) return "";

    // Convert `&amp;` to `&`.
    value = value.replace(/&amp;/gi, "&");
    // Replace spaces.
    value = value.replace(/&nbsp;/gi, " ");
    value = value.replace(/\s+/g, " ");
    // Remove "<b>".
    value = value.replace(/<b>/gi, "");
    value = value.replace(/<\/b>/gi, "");
    // Remove "<script>".
    value = value.replace(/<script(.)*<\/script>/gi, "");
    // Remove "<strong>".
    value = value.replace(/<strong>/gi, "");
    value = value.replace(/<\/strong>/gi, "");
    // Remove "<i>".
    value = value.replace(/<i>/gi, "");
    value = value.replace(/<\/i>/gi, "");
    // Remove "<em>".
    value = value.replace(/<em>/gi, "");
    value = value.replace(/<\/em>/gi, "");
    // Remove "<u>".
    value = value.replace(/<u>/gi, "");
    value = value.replace(/<\/u>/gi, "");

    value = value.replace(/<div>/gi, "\n");
    value = value.replace(/<\/div>/gi, "");
    // Replace "<p>" (from IE).
    value = value.replace(/<p>/gi, "\n");
    value = value.replace(/<\/p>/gi, "");
    // No more than 2x newline, per "paragraph".
    value = value.replace(/\n\n+/g, "\n\n");

    // Whitespace before/after.
    return $.trim(value);
  };

  this.pasteFallback = (e) => {
    setTimeout(() => {
      const el = $(e.target);
      const value = el.text();
      el.text(value);
    }, 16);
  };

  this.safePaste = (e) => {
    // Used in conditional.
    let value = undefined;
    // For IE.
    if (window.clipboardData) {
      value = window.clipboardData.getData("text");
    } else {
      value = e.originalEvent.clipboardData.getData("text/plain");
    }

    if (!value) {
      return window.pasteFallback(e);
    }

    e.preventDefault();
    // Insert into temp `<textarea>`, read back out.
    value = $("<textarea></textarea>").html(value).text();
    // Literal spaces.
    value = $.trim(value).replace(/[ ]+/g, " ");
    // Mix of newlines, spaces.
    value = value.replace(/\n+\s+\n+/g, "\n\n");
    // Double newlines.
    value = value.replace(/\n\n+/g, "\n\n");
    // For IE.
    if (document.selection) {
      if (document.documentMode === 8) {
        value = value.replace(/\n/g, "<br>");
      }
      document.selection.createRange().pasteHTML(value);
    } else {
      document.execCommand("insertText", false, value);
    }
  };

  this.shortifyFileName = (name) => {
    return name.length >= 30
      ? `${name.substring(0, 20)}...${name.substring(name.length - 6, name.length)}`
      : name;
  };

  this.toDate = (value) => {
    let date = new Date(value);
    date.setHours(0);
    date.setMinutes(0);
    date.setSeconds(0);
    date.setMilliseconds(0);
    return date;
  };
}
